module.exports = __webpack_public_path__ + "img/UI_shouji_AP_01_002_fc15c7474.png";